import { HasSeverity, StaticDropDown } from '@app/components/generic/generic'

export enum ScreeningTransition {
  SUBMIT = 'submit',
  INVALIDATE = 'invalidate',
  FIX = 'fix',
  ACCEPT = 'accept',
  SEND_TO_SCREENING = 'send-to-screening',
  PASS_SCREENING = 'pass-screening',
  FAIL_SCREENING = 'fail-screening',
  INACTIVATE = 'inactivate',
  REACTIVATE = 'reactivate',
}

export enum ScreeningState {
  DRAFT = 'draft',
  SUBMITTED = 'submitted',
  INVALID = 'invalid',
  ACCEPTED = 'accepted',
  SENT_TO_SCREENING = 'sent-to-screening',
  PASSED = 'screening-passed',
  FAILED = 'screening-failed',
  INACTIVE = 'inactive',
}
export const SCREENING_WORKFLOW_STATES: Array<StaticDropDown & HasSeverity> = [
  { value: ScreeningState.DRAFT, label_en: 'Draft', label_fr: 'Brouillon', severity: 'warn' },
  { value: ScreeningState.SUBMITTED, label_en: 'Submitted', label_fr: 'Soumise', severity: 'info' },
  { value: ScreeningState.INVALID, label_en: 'To be corrected', label_fr: 'À corriger', severity: 'warn' },
  { value: ScreeningState.ACCEPTED, label_en: 'Ready to be screened', label_fr: 'Prête pour le criblage', severity: 'info' },
  { value: ScreeningState.SENT_TO_SCREENING, label_en: 'Sent to screening', label_fr: 'Envoyée au criblage', severity: 'info' },
  { value: ScreeningState.PASSED, label_en: 'Screening passed', label_fr: 'Criblage réussi', severity: 'success' },
  { value: ScreeningState.FAILED, label_en: 'Screening failed', label_fr: 'Criblage échoué', severity: 'danger' },
  { value: ScreeningState.INACTIVE, label_en: 'Inactive', label_fr: 'Inactif', severity: 'info' },
]
